<template>
  <div>
    <v-breadcrumbs :items="breadcrumbItems"/>

    <v-card v-if="event">
      <v-alert type="warning" v-if="event.notPublished">{{$t('eventmanager.not-published-msg')}}</v-alert>
      <EventHeader :event="event"/>

      <v-card-title>{{$t('events.welcome.enter-verification-code')}}</v-card-title>
      <v-card-text v-if="status && status.verification_required">
        <v-alert type="info">
          {{$t('events.welcome.verification-code-message')}}
        </v-alert>

        <p>
          {{$t('events.welcome.verification-code-description')}}
        </p>

      </v-card-text>
      <v-alert v-if="!$store.getters.isLoading && result && result.status == 'ERROR'" type="error">
        {{$t('events.welcome.verification-code-mismatch')}}
      </v-alert>

      <v-form v-if="status" ref="form" v-model="valid" @submit.prevent="joinEvent" lazy-validation class="mx-4 mb-4">
          <v-text-field 
              v-if="status.verification_required"
              v-model="code" 
              :rules="codeRules" 
              :label="$t('events.welcome.verification-code-label')" 
              :required="status.verification_required">
          </v-text-field>

          <v-checkbox 
            v-if="status.consent_required"
            v-model="consented"
            :rules="consentRules"
            >
            <template v-slot:label>
            <VueMarkdown class="markdown-content">{{event.join_consent_msg}}</VueMarkdown>
            </template>
          </v-checkbox>

          <div v-if="status.gender_required">
            <VueMarkdown class="markdown-content">{{event.join_gender_msg}}</VueMarkdown>
            <v-radio-group v-model="gender" :rules="genderRules" row class="mt-0" >
              <v-radio :label="$t('shared.gender-male')" value="M"></v-radio>
              <v-radio :label="$t('shared.gender-female')" value="F"></v-radio>
            </v-radio-group>
          </div>

          <v-btn color="primary" :loading="$store.getters.isLoading" @click="joinEvent">{{$t('events.welcome.verify-code')}}</v-btn>
      </v-form>
      <br/>
    </v-card>
  </div>
</template>



<script>
import { mapGetters } from "vuex";
import eventService from "@/services/eventService";
import VueMarkdown from 'vue-markdown'
import SodispRules from '@/components/SodispRules.vue';
import EventHeader from '@/components/EventHeader.vue';
import EventJoinCard from '@/components/EventJoinCard.vue';
import profileService from "@/services/profileService";
import firebase from 'firebase/app'
import 'firebase/auth'
import { EventBus } from '@/plugins/eventbus.js';
import tenants from '@/data/tenants.config'
const tenant = tenants.current();

export default {
  name: "EventJoin",
  components: {
    VueMarkdown,
    SodispRules,
    EventHeader,
    EventJoinCard,
  },
  props: {
  },
  data() {
    return {
      tenant: tenant,
      event: null,
      code: null,
      gender: null,
      consented: null,
      status: null,
      profile: null,
      result: null,
      valid: false,
    };
  },

  async mounted() {
    await this.loadEvent(this.$route.params.id);

    EventBus.$on('login-state-change', async user => {
      await this.getEventStatus();
    });

    if (!await firebase.getCurrentUser()) {
      // not logged in, force back into the register flow
      this.$router.push({ name: 'register', query: { event: this.event.id } });
    }
  },

  methods: {
      
    async getEventStatus() {
      if (this.user) {
        var response = await profileService.getEventStatus(this.event.id);
        this.status = response.data;
        this.profile = (await profileService.get(/*full:*/false)).data;

        this.code = this.$route.query.verificationCode;
        if (this.code) {
          await this.joinEvent();
        }
      }
    },

    async joinEvent() {
      if (this.$refs.form.validate()) {
        console.log('Trying to join with code', this.code);
        this.result = (await profileService.joinEvent(this.event.id, this.code, null, this.consented, this.gender)).data;
        if (this.result && this.result.status == "OK") {
          this.$router.replace({ name: "eventWelcome", params: { event: this.event.id} });
          return;
        }
        await this.getEventStatus();
      }
    },
    
    async loadEvent(id) {
      var response = await eventService.get(id);
      this.event = response.data;
      await this.getEventStatus();
      var meta = {
        title: this.event.name + ' on ' + tenant.name,
        description: this.event.description,
        image: this.event.img,
      };
      EventBus.$emit('page-header-change', meta);
    },
    

  },
  computed: {
    isConnected() {
      return this.status && this.status.connected;
    },
    breadcrumbItems() {
      return !this.event ? [] : [
        { text: this.event.name, exact: true, to: { name: 'event', params: {id: this.event.id}} },
        { text: this.$t('events.welcome.join-event'), disabled: true },
      ];
    },
    consentRules() {
      return !this.event || !this.status || !this.status.consent_required ? [] : [
        v => !!v || this.$t('events.welcome.consent-validation-msg'),
      ];
    },
    codeRules() {
      return !this.event || !this.status || !this.status.verification_required ? [] : [
        v => !!v || this.$t('events.welcome.verification-code-validation-msg'),
      ];
    },
    genderRules() {
      return !this.event || !this.status || !this.status.gender_required ? [] : [
        v => !!v || this.$t('events.welcome.gender-validation-msg'),
      ];
    },
    ...mapGetters({
      user: "user"
    })
  },
  async beforeRouteUpdate (to, from, next) {
    // react to route changes...
    await this.loadEvent(to.params.id);
    next();
  },
};
</script>
<style lang="scss">
  .markdown-content {
    p { margin-bottom: 0 !important;}
  }
</style>

